// extracted by mini-css-extract-plugin
export default {"headCard":"Head_headCard__EEaJM","headCardBody":"Head_headCardBody__rUNha","headContent":"Head_headContent__395Bw"};